import { Card } from "@amzn/stencil-react-components/card";
import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

import { EARTH_ILLUSTRATION_PATH } from "../constants";

interface ViewMoreCardProps {
  onExpand: () => void;
}

export const ViewMoreCard: FC<ViewMoreCardProps> = ({ onExpand }) => (
  <Card
    className="use-case-card"
    style={{ padding: 0, cursor: "pointer" }}
    onClick={onExpand}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onExpand();
      }
    }}
  >
    <Col alignItems="center" justifyContent="center" style={{ height: "100%", padding: "2rem" }}>
      <img src={EARTH_ILLUSTRATION_PATH} alt="" width={120} height={120} />
      <Text fontSize="T300" fontWeight="bold" color="primary70" textAlign="center" margin={{ top: "S300" }}>
        {getString("useCases.browsePage.viewMoreCard")}
      </Text>
    </Col>
  </Card>
);
